









































import { Component, Vue, Prop } from 'vue-property-decorator';
import { SetTheme, Theme } from '@/common/themes';
import { Config } from '@/common/config';
import { getModule } from 'vuex-module-decorators';
import StoreVuexModule from '@/stores/StoreVuexModule';
import LoginDialog from '@/components/LoginDialog.vue';

@Component({
  name: 'Brand',
  components: {
    LoginDialog,
  },
})
export default class Brand extends Vue {
  private store = getModule(StoreVuexModule, this.$store);

  public created() {
    this.setDocumentDetail(this.store.currentConfig);
    this.setTheme(this.store.currentConfig);
  }

  // set document title and favicon
  private setDocumentDetail(currentConfig: Config) {
    document.title = 'Mat Selector Widget';
    const link: any = document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = currentConfig.favIconUrl;
    document.getElementsByTagName('head')[0].appendChild(link);
  }

  private setTheme(currentConfig: Config) {
    const theme = new Theme();
    theme.primary = currentConfig.primaryColor;
    theme.secondary = currentConfig.secondaryColor;
    SetTheme(this, theme);
  }
}
